/*
    Monday Task: 8478222625 - Buy Button Profile Listing
*/

import React, { useContext, useEffect, useState } from "react";
import { Card, CardHeader, Container, Row, Col } from "reactstrap";
import { api } from "services/api";
import { AuthContext } from "contexts/AuthContext";
import useFilter from "customHooks/useFilter";
import { getParams } from "utils/commonFunctions";
import PagePagination from "feature/pagination/Pagination";
import useMobileDetection from "customHooks/useMobileDetection";
import { mobileScreenThresholdValue } from "utils/constants";
import Filter from "components/Filters/Filter";
import { clearFilter, removeBadge } from "utils/commonFunctions";
import { removeAllURLParams, addURLParam, processURLSearchParams } from "../../../utils/urls";
import BadgePillFilter from "components/Filters/Badge";
import "../../../utils/commonStyles.css";
import { useLocation } from "react-router-dom";
import ProfileTable from "./ProfileTable";
import { ComponentContext } from "contexts/ComponentContext";
import axios from "axios";
import { onFilterChange } from "utils/commonFunctions";

const ProfileListing = props => {
    const [profileData, setProfileData] = useState([]);
    const [totalOrders, setTotalOrders] = useState(0);
    const [page, setPage] = useState(1);
    const [params, setParams] = useState([]);
    const [pagination, setPagination] = useState({
        previous: null,
        next: null,
        pages: () => {
            return [];
        }
    });
    const [isLoading, setLoading] = useState(false);
    const [selected, setSelected] = useState([]);
    const [refresh, setRefresh] = useState(false);

    const [clearall, setClearAll] = useState(false);

    const [filter, setFilter, clearFilterState] = useFilter({});
    const [sort, setSort] = useState("-id");
    const [sortOrder, setSortOrder] = useState({ order: "", columnName: "" });

    // Check weather screen size is mobile or desktop
    const isMobile = useMobileDetection(mobileScreenThresholdValue);

    const searchInput = document.getElementById("profileNameSearchInput");

    const { component } = useContext(ComponentContext);
    const cancelToken = React.useRef(undefined);

    useEffect(() => {
        setLoading(true);

        let new_params = getParams(filter, setClearAll);
        new_params = { ...new_params, page, ordering: sort };

        console.log(new_params);
        if (cancelToken.current !== undefined) {
            cancelToken.current.cancel("Operation canceled due to new request.");
        }
        cancelToken.current = axios.CancelToken.source();

        api.get("buy-button-profile/", { params: new_params, cancelToken: cancelToken.current.token })
            .then(response => {
                console.log("response: ", response);
                const list = response.data.results.map(order => {
                    const s = selected.filter(item => parseInt(item.id) === order.id);
                    order.checked = s.length > 0;
                    return order;
                });
                setProfileData(list);
                setTotalOrders(response.data.count);
                const totalPages = Math.ceil(response.data.count / window.env.PAGE_SIZE);
                const previous = page !== 1 ? page - 1 : 1;
                const next = page !== totalPages ? page + 1 : totalPages;
                setPagination({
                    previous,
                    next,
                    pages: () => {
                        let startCount = 1;
                        let endCount = isMobile ? 4 : 12;
                        let numberCount = Math.round(endCount / 2);
                        const pageList = [];
                        if (numberCount < 0) numberCount = 1;
                        startCount = page - numberCount;
                        if (startCount <= 0) startCount = 1;
                        if (page !== 1) endCount = page + numberCount;
                        if (endCount > totalPages) endCount = totalPages;
                        if (totalPages >= endCount) {
                            for (let i = startCount; i <= endCount; i++) {
                                pageList.push(i);
                            }
                        } else if (totalPages >= 1) {
                            for (let i = 1; i <= totalPages; i++) pageList.push(i);
                        }
                        return pageList;
                    }
                });
                setLoading(false);
                delete new_params["page"];
                delete new_params["ordering"];
                setParams(new_params);
            })
            .catch(err => {
                console.log(err);
            });
    }, [page, sort, filter, refresh, component, selected, isMobile]);

    const handlePagination = page => {
        setPage(page);
    };

    const handleRefresh = () => {
        setRefresh(!refresh);
    };

    let timer = null;
    const handleSearch = e => {
        addURLParam(window, "search", e.target.value);
        clearTimeout(timer);
        timer = setTimeout(function () {
            setFilter({
                ...filter,
                search: e.target.value
            });
        }, 750);
    };

    const { user, isAuthentication } = useContext(AuthContext);

    const handleClearAll = () => {
        setClearAll(false);
        removeAllURLParams();
        clearFilterState();
        searchInput.value = "";
    };

    const urlSearchParams = useLocation().search;
    React.useMemo(() => {
        if (filter.urlParamsProcessed === false) processURLSearchParams(new URLSearchParams(urlSearchParams), filter, setFilter);
    }, [urlSearchParams, filter, setFilter]);

    // if (isAuthentication && !user.isAdmin) window.location.href = window.env.APP_URL;
    return (
        <>
            {isAuthentication && (
                <Container fluid>
                    <div className={"pt-7"}>
                        {isAuthentication && (
                            <Row className={"mb-2"}>
                                <Col xs={10} lg={"2"} className={"text-left"}>
                                    <input
                                        type="text"
                                        className={"button-font-size form-control form-control-sm"}
                                        placeholder={"Search Profile Name..."}
                                        id="profileNameSearchInput"
                                        defaultValue={filter.search}
                                        onChange={handleSearch}
                                        newparams={""}
                                    />
                                </Col>
                                <Col xs={2} lg={"10"} className={"text-right"}>
                                    <div className={"d-none d-lg-inline-block mr-2"}>
                                        <div className="mb-1 d-inline">
                                            <button className="button-font-size btn btn-neutral btn-sm mr-2 p-9px" onClick={handleRefresh}>
                                                <i className="fas fa-sync-alt"></i>
                                            </button>
                                        </div>

                                        {/* Monday Task: 8899629353 - Added Store filter */}
                                        <Filter
                                            name={"Store"}
                                            prefix={"store"}
                                            onChange={e => onFilterChange(e, "store", filter, setFilter, setPage)}
                                            newparams={params}
                                            selected={filter.store}
                                            url={"order/shipping-chargebacks/filter/store"}
                                            onClear={() => clearFilter("store", setFilter, setClearAll, setPage)}
                                        />

                                        <Filter
                                            name={"Brand"}
                                            prefix={"brand"}
                                            onChange={e => onFilterChange(e, "brand", filter, setFilter, setPage)}
                                            newparams={params}
                                            selected={filter.brands}
                                            url={"/product/filter/brand/"}
                                            onClear={() => clearFilter("brand", setFilter, setClearAll, setPage)}
                                        />

                                        <Filter
                                            name={"Product"}
                                            prefix={"product"}
                                            onChange={e => onFilterChange(e, "product", filter, setFilter, setPage)}
                                            newparams={params}
                                            selected={filter.products}
                                            url={"buy-button-profile/products-filter/"}
                                            onClear={() => clearFilter("product", setFilter, setClearAll, setPage)}
                                        />
                                        <a href={window.env.APP_URL + "product/profile/create"} className="button-font-size btn btn-success btn-sm">
                                            <i className="fas fa-plus"></i> Add Profile
                                        </a>
                                    </div>
                                </Col>
                            </Row>
                        )}
                        <Row>
                            {isAuthentication && (
                                <div className="col">
                                    <Card className="shadow ">
                                        <CardHeader className="border-0">
                                            <Row>
                                                <Col>
                                                    <div className="d-flex">
                                                        <h3
                                                            className="mb-2"
                                                            style={{
                                                                display: "inline-block",
                                                                paddingRight: "5px"
                                                            }}>
                                                            Buy Button Profiles <small>&nbsp;({totalOrders})</small>
                                                        </h3>
                                                        {clearall > 0 && (
                                                            <a
                                                                href={void 0}
                                                                className="badge badge-pill badge-secondary bg-primary text-white filter-pill"
                                                                onClick={handleClearAll}
                                                                id="clear_all_filters">
                                                                <i className="fas fa-times-circle"></i> Clear All filters
                                                            </a>
                                                        )}
                                                    </div>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col sm="12">
                                                    <BadgePillFilter
                                                        data={filter}
                                                        selected={selected}
                                                        onClick={e => {
                                                            removeBadge(e, filter, setFilter, selected, setSelected, () => {}, searchInput);
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                        </CardHeader>
                                        {isLoading ? (
                                            <div className="text-center mt-3 mb-3">
                                                <div className="spinner-border" role="status">
                                                    <span className="sr-only">Loading...</span>
                                                </div>
                                            </div>
                                        ) : (
                                            <>
                                                <ProfileTable
                                                    profileData={profileData}
                                                    sort={sort}
                                                    setSort={setSort}
                                                    setSortOrder={setSortOrder}
                                                    sortOrder={sortOrder}
                                                />
                                                <PagePagination
                                                    pagination={pagination}
                                                    handlePagination={handlePagination}
                                                    page={page}
                                                    totalCount={totalOrders}
                                                />
                                            </>
                                        )}
                                    </Card>
                                </div>
                            )}
                        </Row>
                    </div>
                </Container>
            )}
        </>
    );
};
export default ProfileListing;
